import type { ReactNode } from "react";
import {
  OverlayTrigger,
  type OverlayTriggerProps,
  Popover,
} from "react-bootstrap";

type TooltipComponentProps = {
  header?: ReactNode;
  content: ReactNode;
  placement?: OverlayTriggerProps["placement"];
  children: ReactNode;
};

export const RollingResourceLinkTooltipComponent = ({
  header,
  content,
  placement = "auto",
  children,
}: TooltipComponentProps) => {
  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 200, hide: 200 }}
      //trigger={["hover", "focus"]}
      overlay={
        <Popover className="!p-2 w-[250px]">
          {header && (
            <Popover.Header
              className="
                !text-white
                !font-['DM_Sans',sans-serif]
                !transition-[background,color] duration-[400ms] ease-[cubic-bezier(1,0,0.4,1)]
                !p-[15px] !rounded-[16px]
                [--c-glass:#313030f8]
                [--c-light:#fff]
                [--c-dark:#000]
                [--c-content:#224]
                [--c-action:#0052f5]
                [--c-bg:#e8e8e9]
                [--glass-reflex-dark:1]
                [--glass-reflex-light:1]
                [--saturation:150%]
                !bg-[color-mix(in_srgb,var(--c-glass)_82%,transparent)]
                backdrop-blur-[8px]
                backdrop-saturate-[var(--saturation)]
                backdrop-filter-[url(#switcher)]
                [-webkit-backdrop-filter:blur(8px)_saturate(var(--saturation))]
                !shadow-[inset_0_0_0_1px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*10%),transparent),inset_6px_6px_6px_-6px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*90%),transparent),inset_-4px_-4px_0px_-2px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*80%),transparent),inset_-3px_-8px_1px_-6px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*60%),transparent),inset_-0.3px_-1px_4px_0px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*12%),transparent),inset_-1.5px_2.5px_0px_-2px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*20%),transparent),inset_0px_3px_4px_-2px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*20%),transparent),inset_2px_-6.5px_1px_-4px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*10%),transparent),0px_1px_5px_0px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*10%),transparent),0px_6px_16px_0px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*8%),transparent)]
            "
            >
              {header}
            </Popover.Header>
          )}
          <Popover.Body
            className="
                !text-white
                !font-['DM_Sans',sans-serif]
                !transition-[background,color] duration-[400ms] ease-[cubic-bezier(1,0,0.4,1)]
                !p-[15px] !rounded-[16px]
                [--c-glass:#313030f8]
                [--c-light:#fff]
                [--c-dark:#000]
                [--c-content:#224]
                [--c-action:#0052f5]
                [--c-bg:#e8e8e9]
                [--glass-reflex-dark:1]
                [--glass-reflex-light:1]
                [--saturation:150%]
                !bg-[color-mix(in_srgb,var(--c-glass)_82%,transparent)]
                backdrop-blur-[8px]
                backdrop-saturate-[var(--saturation)]
                backdrop-filter-[url(#switcher)]
                [-webkit-backdrop-filter:blur(8px)_saturate(var(--saturation))]
                !shadow-[inset_0_0_0_1px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*10%),transparent),inset_6px_6px_6px_-6px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*90%),transparent),inset_-4px_-4px_0px_-2px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*80%),transparent),inset_-3px_-8px_1px_-6px_color-mix(in_srgb,var(--c-light)_calc(var(--glass-reflex-light)*60%),transparent),inset_-0.3px_-1px_4px_0px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*12%),transparent),inset_-1.5px_2.5px_0px_-2px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*20%),transparent),inset_0px_3px_4px_-2px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*20%),transparent),inset_2px_-6.5px_1px_-4px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*10%),transparent),0px_1px_5px_0px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*10%),transparent),0px_6px_16px_0px_color-mix(in_srgb,var(--c-dark)_calc(var(--glass-reflex-dark)*8%),transparent)]
            "
          >
            {content}
          </Popover.Body>
        </Popover>
      }
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};
